import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import {
  SendPokeshardsInput,
  SendPokeshardsOutput,
  WebAppRoutes,
} from "types/web-app";

export const sendPokeshards = async (
  accessToken: string,
  input: SendPokeshardsInput,
) => {
  try {
    const response = await fetchWithAuth(
      "/" + WebAppRoutes.SEND_POKESHARDS,
      accessToken,
      {
        method: "POST",
        body: JSON.stringify(input),
      },
    );

    return (await response.json()) as ServiceResponse<SendPokeshardsOutput>;
  } catch (error) {
    console.error(error);

    throw error;
  }
};
